import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import OnboardingModal from 'src/components/OnboardingModal';
import { useChurnkeyCheck } from 'src/utils/useChurnkeyPausewall';
import { useOrganisationInvitation } from 'src/utils/useOrganisationInvitation';
import { useUserAndOrganisation } from 'src/utils/useUserAndOrganisation';
import { NewInvitedUserOnboardingModal } from 'src/components/OnboardingModal/NewInvitedUserOnboardingModal';
import { OrganisationInvitationModal } from '../OrganisationInvitation';
import './churnkey.css';

const UniversalModals: FC = () => {
  const user = useUserAndOrganisation();
  const { inviteCode } = useOrganisationInvitation();
  const { pathname } = useLocation();
  const [isOnboarding, setIsOnboarding] = useState(false);

  const isNewInvitedUser =
    user.data?.organisation.name !== 'My Organisation' &&
    !user.data?.isOnboarded;

  // shows pausewall if organisation subscription is paused
  useChurnkeyCheck({
    show: user.data?.planStatus === 'paused',
    stripeCustomerID: user.data?.organisation.stripeCustomerID,
  });

  useEffect(() => {
    const isUserEligibleToOnboard =
      user.data && !user.data.isOnboarded && !isOnboarding;

    if (isUserEligibleToOnboard) {
      setIsOnboarding(true);
    }
  }, [user.data, isOnboarding]);

  // Avoid showing onboarding modal on oauth exchange routes. i.e /tiktok/oauth
  const isOauthRoute = pathname.endsWith('/oauth');

  const showOnboardingModal =
    user.data && isOnboarding && !inviteCode && !isOauthRoute;

  return (
    <>
      {showOnboardingModal && (
        <>
          {isNewInvitedUser ? (
            <NewInvitedUserOnboardingModal
              isNewInvitedUser={true}
              onComplete={() => setIsOnboarding(false)}
            />
          ) : (
            <OnboardingModal
              isNewInvitedUser={isNewInvitedUser}
              onComplete={() => {
                setIsOnboarding(false);
              }}
            />
          )}
        </>
      )}
      <OrganisationInvitationModal />
    </>
  );
};

export default UniversalModals;
